module.exports = __webpack_public_path__ + "img/menu-icon-3-2.2a140dac.svg";